import React from "react";
import { Link, withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import application from "../../../data/application.json"

import * as actions from "../../../actions/auth";
import {allEntity, entityCanModify} from "../../../utils/metaUtil";

class Nav extends React.Component {
  constructor(props) {
    super(props);
    this.doSearch = this.doSearch.bind(this);
  }

  doSearch(event) {
    if (event.keyCode === 13) {
      this.props.history.push(`/search/${event.target.value}`);
    }
  }

  render() {
    const { isAuthenticated, name, logout, meta} = this.props;
    return (
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
        <div className="navbar-brand">
            {application.name}
        </div>
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon" />
        </button>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav mr-auto">
              <li className="nav-item dropdown">
                  <a
                      className="nav-link dropdown-toggle"
                      href="#"
                      id="navbarDropdown"
                      role="button"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                  >
                     Entities
                  </a>
                  {meta && (<div className="dropdown-menu" aria-labelledby="navbarDropdown">
                      {Object.keys(allEntity(meta)).map(e=>{
                          if (entityCanModify(meta, e)) {
                              return (
                                  <Link key={e} to={`/entity/${e}`} className="dropdown-item">
                                      {e}
                                  </Link>
                              )
                          }
                      })}
                  </div>
                  )}
              </li>
              <li className="nav-item dropdown">
                  <a
                      className="nav-link dropdown-toggle"
                      href="#"
                      id="navbarDropdown"
                      role="button"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                  >
                      Lookup Values
                  </a>
                  {meta &&
                  (<div className="dropdown-menu" aria-labelledby="navbarDropdown">
                      {Object.keys(allEntity(meta)).map(e=>{
                          if (!entityCanModify(meta, e)) {
                              return (
                                  <Link key={e} to={`/entity/${e}`} className="dropdown-item">
                                      {e}
                                  </Link>
                              )
                          }
                      })}
                  </div>
                  )}
              </li>
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                href="#"
                id="navbarDropdown"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                  {name}
              </a>
              <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                <a className="dropdown-item" href="#">
                  Action
                </a>
                <a className="dropdown-item" href="#">
                  Another action
                </a>
                <div className="dropdown-divider" />
                <a className="dropdown-item" href="#">
                  Something else here
                </a>
              </div>
            </li>
          </ul>
          <form className="form-inline my-2 my-lg-0">
            <input
              className="form-control mr-sm-2"
              type="search"
              placeholder="Search"
              aria-label="Search"
            />
            <button
              className="btn btn-outline-success my-2 my-sm-0"
              type="submit"
            >
              Search
            </button>
          </form>
        </div>
      </nav>
    );
  }
}
Nav.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  logout: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  meta: PropTypes.shape().isRequired
};
Nav.defaultProps = {};

export default withRouter(connect(null, { logout: actions.logout })(Nav));



// WEBPACK FOOTER //
// ./src/components/widgets/nav/Nav.js